import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { apigetHomePyqDetails } from "../../services/apihomePyqs/apihomepyq";
import useAuth from "../../services/store/useAuth";
import { Lock } from "lucide-react";

export default function Pyqdetailpage () {

    const { slug } = useParams();
    const { userdetails } = useAuth();
    const [pyq, setPyq] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPyqDetails = async () => {
            try {
                const res = await apigetHomePyqDetails(slug);
            if (res?.resdata?.[0]) {
                setPyq(res.resdata[0]);
            }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPyqDetails();
    }, [slug]);

    const handleViewSection = (sectionId) => {
        navigate(`/pyq-papers/${slug}/${sectionId}`);
    };

    if (loading) {
        return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 border-4 border-blue-900 rounded-full border-t-transparent animate-spin"></div>
            <p className="text-gray-600">Loading...</p>
            </div>
        </div>
        );
    }

    if (!pyq) {
        return (
        <div className="flex items-center justify-center min-h-screen">
            <p className="text-lg text-gray-600">No data found</p>
        </div>
        );
  }

    return (
        <>
        <section className="bg-regal-blue">
            <div className="max-w-[85rem] mx-auto px-4 py-8">
                <div className="grid items-center gap-8 md:grid-cols-2">
                    <div className="text-center text-white">
                        <h1 className="mb-4 text-4xl font-bold md:text-5xl">{pyq?.Title || 'Title'}</h1>
                        <p className="p-2 text-xl font-semibold text-center rounded-md bg-regal-yellow text-regal-blue">Category : {pyq.Category}</p>
                    </div>
                </div>
            </div>
        </section>
        <section className="max-w-[85rem] mx-auto px-4 py-12">
            <div className="p-8 bg-white shadow-[0px_0px_29px_0px_rgba(0,_0,_0,_0.1)] rounded-xl border-regal-yellow">
                <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: pyq.Description }}></div>
            </div>
        </section>

         <section className="max-w-[85rem] mx-auto px-4 pb-16">
        <h2 className="mb-8 text-3xl font-bold text-center text-gray-800">
          Available Question Papers
        </h2>
        
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {pyq.sections?.map((section) => (
            <div key={section._id} className="overflow-hidden transition-all duration-300 bg-white border border-gray-200 shadow-lg rounded-2xl ">
              <div className="p-6 bg-gradient-to-r from-[#EB5C45] to-[#F59349]">
                <h3 className="text-2xl font-bold text-center text-white">
                  {section.sectionTitle}
                </h3>
              </div>

              <div className="p-6">
                <div className="flex items-center justify-center gap-4 mb-6">
                  <div className="text-center">
                    <p className="text-3xl font-bold text-blue-900">
                      {section.media_files?.length || 0}
                    </p>
                    <p className="text-sm text-gray-600">Files</p>
                  </div>
                  <div className="w-px h-12 bg-gray-300"></div>
                  <div className="text-center">
                    <p className="text-3xl font-bold text-blue-900">
                      {section.media_files?.filter(f => f.file_type === 'pdf').length || 0}
                    </p>
                    <p className="text-sm text-gray-600">PDFs</p>
                  </div>
                  <div className="w-px h-12 bg-gray-300"></div>
                  <div className="text-center">
                    <p className="text-3xl font-bold text-blue-900">
                      {section.media_files?.filter(f => f.file_type === 'video').length || 0}
                    </p>
                    <p className="text-sm text-gray-600">Videos</p>
                  </div>
                </div>

                <div className="mb-6 space-y-2">
                  <p className="mb-3 text-sm font-semibold text-gray-700">Contents:</p>
                  {section.media_files?.slice(0, 3).map((file) => (
                    <div
                      key={file._id}
                      className="flex items-center gap-2 p-2 text-sm text-gray-600 rounded bg-gray-50"
                    >
                      {file.file_type === 'pdf' ? (
                        <svg className="w-4 h-4 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" />
                        </svg>
                      ) : (
                        <svg className="w-4 h-4 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
                        </svg>
                      )}
                      <span className="truncate">{file.title}</span>
                    </div>
                  ))}
                  {section.media_files?.length > 3 && (
                    <p className="pt-1 text-xs text-center text-gray-500">
                      +{section.media_files.length - 3} more files
                    </p>
                  )}
                </div>

               {!userdetails ? (
                    <Link to={"/login"}>
                        <button className="flex items-center justify-center w-full gap-2 px-4 py-2 mt-5 font-bold text-white transition-all duration-200 transform shadow-lg bg-regal-blue rounded-xl ">
                          <Lock/> Login to View
                        </button>
                      </Link>
               ) : (
                <button onClick={() => handleViewSection(section._id)}
                  className="flex items-center justify-center w-full gap-2 px-6 py-3 font-bold text-blue-900 transition-all duration-300 transform rounded-lg shadow-md bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 hover:shadow-lg"
                >
                  <span>View Papers</span>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>)}
              </div>
            </div>
          ))}
        </div>

        {(!pyq.sections || pyq.sections.length === 0) && (
          <div className="py-16 text-center">
            <svg className="w-24 h-24 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p className="text-xl text-gray-500">No question papers available yet</p>
          </div>
        )}
      </section>
        </>
    )
}